<template>
	<div>
		<div style="overflow:auto !important;height: 90vh;">
			<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
				
				<FormItem prop="trackName" :label="this.$t('Station')" :label-width="100">
					<Select :placeholder="this.$t('Station')" style="width: 200px;" v-model="formInline.StationId">
						<Option :value=0>{{ this.$t('Common.All') }}</Option>
						<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">
							{{item.StationName}}
						</Option>
						
					</Select>
				</FormItem>
				<FormItem prop="trackName" :label="this.$t('EquipmentNo')" :label-width="100">
					<Input type="text" v-model="formInline.EquipmentNo" :placeholder="this.$t('EquipmentNo')" />
				</FormItem>
				<FormItem v-if='Control.select'>
					<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">{{ $t('Common.Search') }}</Button>
				</FormItem>
			</Form>
			<Card style="margin-bottom: 20px;box-shadow: 2px 2px 4px #a7a7a7;width: 100%;background-color: white;">
				<Row>
					<Col span="5">
					<Tag color="#5500ff" type="dot" size="large" style="font-size: 18px;">{{ $t('StationMonitoring.TotalQty')+":"+Summary.Total}}</Tag>
					</Col>
					<Col span="5">
					<Tag color="primary" type="dot" size="large" style="font-size: 18px;">{{ $t('StationMonitoring.ChargingQty') }}:{{Summary.Charging}}</Tag>
					</Col>
					<Col span="5">
					<Tag color="success" type="dot" size="large" style="font-size: 18px;">{{ $t('StationMonitoring.StandbyQty') }}:{{Summary.Standby}}</Tag>
					</Col>
					<Col span="5">
					<Tag color="#bbbbbb" type="dot" size="large" style="font-size: 18px;">{{ $t('StationMonitoring.OfflineQty') }}:{{Summary.Offline}}</Tag>
					</Col>
					<Col span="4">
					<Tag color="#ed4e4c" type="dot" size="large" style="font-size: 18px;">{{ $t('StationMonitoring.AlarmingQty') }}:{{Summary.Alarming}}</Tag>
					</Col>
				</Row>
			</Card>
			<template v-for="(statusItem, idx) in statusList">
				<div :key="idx" style="margin-bottom: 20px; text-align: left;">
					<Tag slot="title" class="label" :color="statusItem.color" type="dot">{{statusItem.statusDesc}}</Tag>
					<Row :gutter="12" type="flex" justify="start" class="chargeCardClass">
						<Col class="col-24 col-md-12 col-lg-8 col-xxl-6 col-xxl-5 col-xxl-4" v-bind:key="index"
							v-for="(item, index) in statusItem.statusData">
						<Card :class="titleColor(item.WorkStatus)">
							<p slot="title">
								
								<span class="1" style="font-size: 1rem;">{{item.ConnectorType==4?'DC |':'AC |'}}</span>
								<span style="font-size: 1rem;">
									{{item.ConnectorNo}}{{item.EquipmentSerialNo ?'/':''}}{{item.EquipmentSerialNo}}</span>
							</p>
							<a style="color: #000000;font-size: 0.75rem;" href="#" slot="extra"
								@click.prevent="detail(item.ConnectorNo,item.WorkStatus)">
								<!-- <Icon type="ios-loop-strong"></Icon> -->
								<Icon type="ios-browsers-outline" size="24" color="white" />
							</a>
							<div class="freeDiv">
								<div class="cicle_p circle-div">
									<i-circle :percent="100" :size="72" :stroke-color="circleColor(item.WorkStatus)" :stroke-width="8"
										:trail-width="8">
										<p :style="circleTextColor(item.WorkStatus)"> {{  item.WorkStatus|WorkStatusDesc }}</p>
										<p v-if="item.ConnectorType==4 && item.WorkStatus == 2" :style="'font-size:1rem;margin-top: 5px;' + circleTextColor(item.WorkStatus)">
											{{item.CurrentSoc}}%
										</p>
									</i-circle>
								</div>
								<div class="statusCard">
									<div v-if="item.WorkStatus == 2">
										<!-- <Col span="24"> -->
										<Row style="margin-bottom: 10px;text-align: left;">
											<Col span="12">
											<span>
												<Icon type="ios-pricetag" size="15" />{{ $t('StationMonitoring.ChargeVoltage') }}:
											</span>
											<span>{{item.ChargeVoltage}} V</span>
											</Col>
											<Col span="12">
											<span>
												<Icon type="ios-pricetag" size="15" />{{ $t('StationMonitoring.ChargeCurrent') }}:
											</span>
											<span>
												{{item.ChargeCurrent}} A
											</span>
											</Col>
										</Row>
										<Row style="margin-bottom: 10px;text-align: left;">
											<Col span="12">
											<span>
												<Icon type="ios-pricetag" size="15" />{{ $t('StationMonitoring.ChargeDuration') }}:
											</span>
											<span>
												{{item.ChargeDurationDesc}}
											</span>
											</Col>
											
											<Col span="12">
											<span>
												<Icon type="ios-pricetag" size="15" />{{ $t('StationMonitoring.ChargePower') }}:
											</span>
											<span>
												{{item.ChargePower.toFixed(2)}} kW
											</span>
											</Col>
										</Row>
										<Row style="margin-bottom: 10px;text-align: left;">
											<Col span="12">
											<span>
												<Icon type="ios-pricetag" size="15" />{{ $t('StationMonitoring.ChargeKwh') }}:
											</span>
											<span>
												{{item.ChargeKwh}} kWh
											</span>
											</Col>
											<Col span="12">
											<span>
												<Icon type="ios-pricetag" size="15" />{{ $t('StationMonitoring.ChargeCost') }}:
											</span>
											<span>
												{{item.ChargeCost}} {{ $t('StationMonitoring.RMB') }}
											</span>
											</Col>
										</Row>
										<!-- </Col> -->
									</div>
									<div v-else>
										<!-- <Col span="24"> -->
										<Row style="text-align: left;" v-if="item.WorkStatus==6">
											<Col span="24">
											<span>
												{{ $t('StationMonitoring.AlarmDescription') }}：
											</span>
											<span>
												{{item.MaxAlarmDesc}}
											</span>
											</Col>
										</Row>
										<Row style="text-align: left;" v-else-if="item.WorkStatus==0">
											<Col span="24">
											<span>
												{{ $t('StationMonitoring.CarCoupleStatus') }}：
											</span>
											<span>
												{{ item.CarCoupleStatus | CarCoupleStatusDesc }}
												
											</span>
											</Col>
										</Row>
										<Row style="text-align: left;" v-else-if="item.WorkStatus==3">
											<Col span="24">
											<span>
												{{ $t('StationMonitoring.CarCoupleStatus') }}：
											</span>
											<span>
											    {{ item.CarCoupleStatus | CarCoupleStatusDesc }}
											</span>
											</Col>
										</Row>
										<Row style="text-align: left;" v-else-if="item.WorkStatus==-1">
											<Col span="24">
											<span>
												{{ $t('StationMonitoring.OfflineTime') }}：
											</span>
											<span>
												{{ item.OfflineTime ? formatLocalTime(item.OfflineTime) : '' }}
											</span>
											</Col>
										</Row>
										<Row style="text-align: left;" v-else>
											<Col span="24">
											<span>
												{{ $t('StationMonitoring.CarCoupleStatus') }}：
											</span>
											<span>
												{{ item.CarCoupleStatus | CarCoupleStatusDesc }}
											</span>
											</Col>
										</Row>
										<!-- </Col> -->
									</div>
								</div>
							</div>
						</Card>
						</Col>
					</Row>
					<!-- <Button type="dashed" long v-on:click="showMore(idx)"
						:disabled="isAllShowed(idx)">{{ statusItem.statusData.length == statusItem.statusDataTotal.length ? this.$t('StationMonitoring.LoadedAll') : this.$t('StationMonitoring.LoadMore') }}
					</Button>  -->

					<Button type="dashed" long v-on:click="showMore(idx)"
						:disabled="isAllShowed(idx)">{{ statusItem.statusData.length == statusItem.statusDataTotal.length ?  "Load All" : "Load More" }}
					</Button> 

				</div>
			</template>
			<Modal v-model="showModel" :title="this.$t('StationMonitoring.DeviceStatusDetails')" width="80%">
				<Tabs value="name1">
					<TabPane :label="this.$t('EquipmentStatus')" name="name1">
						<Table :columns="columns1" :data="dataDetail" ref="table" size="small"></Table>
					</TabPane>
					<TabPane :label="this.$t('StationMonitoring.OrderDetails')" name="name2">
						<Table :columns="columns2" :data="dataDetail" v-if="tableShow" ref="table2" size="small"></Table>
					</TabPane>
				</Tabs>
			</Modal>
			<!-- <MyPage ref="sonPage" :param="pageParam" :url="getEqumentStatusBaseUrl" @listData='getDeviceData'></MyPage> -->
		</div>
	</div>
</template>

<script>
	// import echarts1 from "../../../js/echarts_hot.js";
	// import dateFormat from '../../../../public/js/comm.js'
	// import Qs from 'qs'
	import {
		mapState,
		// mapGetters,
		// mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';
	import { formatLocalTime } from "../../../utils/date"

	export default {
		data() {
			
			return {
				getEqumentStatusBaseUrl: webapi.base_api_url + '/Operations/GetEqumentStatusBase',
				Control: {},
				loadingStatus: false,
				//
				params: "", //
				
				showModel: false,
				
				tableShow: true,
				tableHeight: "650",
				
				Summary: {
					Total: 0,
					Charging: 0,
					Standby: 0,
					Offline: 0,
					Alarming: 0,
				},
				BreadcrumbList: [this.$t('stationMonitoring'), '>>', this.$t('equipmentMonitoring')],
				formInline: {
					StationId: 0,
					EquipmentNo: ''
				},
				
				columns1: [{
						title: this.$t('EquipmentNo'),
						key: 'EquipmentNo',
					}, {
						title: this.$t('EquipmentName'),
						key: 'EquipmentName',
					},
					{
						title: this.$t('ConnectorNo'),
						key: 'ConnectorNo'
					},
					{
						title: this.$t('ConnectorName'),
						key: 'ConnectorName'
					},
					{
						title: this.$t('EquipmentType'),
						key: 'EquipmentType',
						render: (h, params) => {
							let type = ''
							switch (params.row.EquipmentType) {
								case 1:
									type = this.$t('DCCharger')
									break;
								case 2:
									type = this.$t('ACCharger')
									break;
								case 3:
									type = this.$t('ACDCIntegrated')
									break;
								case 4:
									type =this.$t('WirelessCharger')
									break;
								default:
									type = this.$t('Other')
									break;
							}
							return h('div',
								type
							);
						}
					},
					{
						title: this.$t('ConnectorType'),
						key: 'ConnectorType',
						width: 300,
						render: (h, params) => {
							let type = ''
							switch (params.row.ConnectorType) {
								case 1:
									type = this.$t('StationMonitoring.HouseholdSocket') 
									break;
								case 2:
									type = this.$t('StationMonitoring.ACConnectorSocketMethodB') 
									break;
								case 3:
									type = this.$t('StationMonitoring.ACConnectorSocketMethodC') 
									break;
								case 4:
									type = this.$t('StationMonitoring.DCConnector') 
									break;
								case 5:
									type = this.$t('StationMonitoring.HighPowerAC') 
									break;
								default:
									type = this.$t('Other')
									break;
							}
							return h('div',
								type
							);
						}
					},
					{
						title: this.$t('WorkStatus'),
						key: 'WorkStatus',
						render: (h, params) => {
							let type = ''
							switch (params.row.WorkStatus) {
								case 0:
									type = this.$t('StationMonitoring.Standby')
									break;
								case 1:
									type = this.$t('StationMonitoring.ChargingStarting')
									break;
								case 2:
									type = this.$t('StationMonitoring.Charging')
									break;
								case 6:
									type = this.$t('StationMonitoring.Alarming')
									break;
								case -1:
									type = this.$t('StationMonitoring.Offline')
									break;
								default:
									type = this.$t('Other')
									break;
							}
							return h('div',
								type
							);
						}
					},
					{
						title: this.$t('StationMonitoring.MaxAlarmCode'),
						key: 'MaxAlarmCode',
						render: (h, params) => {
							let type = ''
							let color = ''
							switch (params.row.MaxAlarmCode) {
								case 0:
									color = "success",
									type = this.$t('StationMonitoring.NoAlarm')
									break;
								default:
									color = "error",
										type = params.row.MaxAlarmDesc
									break;
							}
							return h('Tag', {
									props: {
										color: color
									}
								},
								type
							);
						}
					},
					{
						title: this.$t('StationMonitoring.CarCoupleStatus'),
						key: 'CarCoupleStatus',
						render: (h, params) => {
							let type = ''
							let color = ''
							switch (params.row.CarCoupleStatus) {
								case 0:
									color = "error",
										type = this.$t('StationMonitoring.Disconnected')
									break;
								default:
									color = "success",
										type = this.$t('StationMonitoring.Connected')
									break;
							}
							return h('Tag', {
									props: {
										color: color
									}
								},
								type
							);
						}
					},
					{
						title: this.$t('StationMonitoring.RatedPower'),
						key: 'RatedPower'
					},
					{
						title: this.$t('StationName'),
						key: 'StationName'
					}
				],
				//table2
				columns2: [{
						title: this.$t('StationMonitoring.OrderNo'),
						key: 'OrderNo',
						width: 260
					}, {
						title: this.$t('StationMonitoring.ChargeStartTime') ,
						key: 'ChargeStartTime',
						width: 160,
						render: (h, params) => {
							return h('div', formatLocalTime(params.row.ChargeStartTime))
						}
					},
					{
						title: this.$t('StationMonitoring.StartModeDesc'),
						key: 'StartModeDesc',
						width: 110
					},
					{
						title: this.$t('StationMonitoring.ChargeVoltage'),
						key: 'ChargeVoltage',
						width: 110
					},
					{
						title: this.$t('StationMonitoring.ChargeCurrent') ,
						key: 'ChargeCurrent',
						width: 110
					},
					{
						title: this.$t('StationMonitoring.ChargeDuration'),
						key: 'ChargeDuration',
						width: 110,
						render: (h, params) => {
							return h('div',
								params.row.ChargeDurationDesc
							);
						}
					},
					{
						title: this.$t('StationMonitoring.ChargePower') ,
						key: 'ChargePower',
						width: 110,
					},
					{
						title: this.$t('StationMonitoring.ChargeKwh') ,
						key: 'ChargeKwh',
						width: 110,
					},
					{
						title: this.$t('StationMonitoring.ChargeCost') ,
						key: 'ChargeCost',
						width: 110,
					},
					{
						title: this.$t('StationMonitoring.Current')+'SOC',
						key: 'CurrentSoc',
						width: 110,
					},
					{
						title:  this.$t('StationMonitoring.RemainDuration'),
						key: 'StationName',
						width: 110,
						render: (h, params) => {
							return h('div',
								params.row.RemainDurationDesc
							);
						}
					},
					{
						title: this.$t('StationMonitoring.CardNo'),
						key: 'CardNo',
						width: 270
					},
					{
						title: this.$t('StationMonitoring.MemberPhone') ,
						key: 'MemberPhone',
						width: 110,
					},
					{
						title: this.$t('StationMonitoring.MemberName') ,
						key: 'MemberName',
						width: 110,
					},
					{
						title:  this.$t('StationMonitoring.BatteryTemp'),
						key: 'BatteryTemp',
						width: 110,
					},
					{
						title: this.$t('StationMonitoring.ConnectorTemp'),
						key: 'ConnectorTemp',
						width: 110,
					},
					{
						title: this.$t('StationMonitoring.CarVIN'),
						key: 'VIN',
						width: 110,
					}
				],
				dataCharging: [],
				dataStandby: [],
				dataFault: [],
				dataOffline: [],
				dataDetail: [],
				statusList: [{
					statusDesc: this.$t('StationMonitoring.Charging'),
					color: '#2d8cf0',
					statusData: [],
					statusDataTotal: [],
					showNum: 20,
				}, {
					statusDesc: this.$t('StationMonitoring.Standby'),
					color: '#19be6b',
					statusData: [],
					statusDataTotal: [],
					showNum: 20,
				}, {
					statusDesc: this.$t('StationMonitoring.Alarming'),
					color: '#ed4e4c',
					statusData: [],
					statusDataTotal: [],
					showNum: 20,
				}, {
					statusDesc: this.$t('StationMonitoring.Offline'),
					color: '#aaaaaa',
					statusData: [],
					statusDataTotal: [],
					showNum: 20,
				}],
				timer: ''
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 300;
			window.addEventListener('resize', this.getTableHeight)
		},
		activated() {
			let col = this.$store.state.UserButton.find(item => window.location.href.indexOf(item.path) > 0);
			this.Control = col.control
			// console.log(col.control);
			this.timer = setInterval(this.handleSubmit, 30000);
		},
		deactivated() {
			if (this.timer) {
				clearInterval(this.timer); 
			}
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		updated() {},
		mounted() {
			const _this = this;
			this.$nextTick(function() {
				
				_this.handleSubmit();
				// }, 1000);
			})
			//_this.getButton()
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer); 
			}
		},
		computed: {
			getCircleSize: function() {
				//console.log(document.body.clientWidth / 60 + 'px')
				return document.body.clientWidth / 12
			},
			
			pageParam: function() {
				const _this = this;
				const param = _this.formInline
				return param
			},
			
			...mapState({
				StationList: 'Stations',
			}),
			
		},
		methods: {
			formatLocalTime,
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				//this.$refs.sonPage.getList();
				const _this = this
				const params = _this.formInline;
				params.page = 0;
				params.pageSize = 0;
				_this.$axios.post(webapi.base_api_url + '/Operations/GetEqumentStatusBase', params).then(res => {
					if (res.data.code != 1) {
						_this.dataCharging = res.data.Data.List.filter((currentValue) => currentValue.WorkStatus === 2);

						// Charging
						let idx = 0;
						_this.statusList[idx].statusDataTotal = _this.dataCharging = res.data.Data.List.filter((
							currentValue) => currentValue.WorkStatus == 2);
						_this.statusList[idx].statusData = _this.statusList[idx].statusDataTotal.slice(0, Math.min(_this
							.statusList[idx].showNum, _this.statusList[idx].statusDataTotal.length));

						// Standby
						idx++
						_this.statusList[idx].statusDataTotal = _this.dataStandby = res.data.Data.List.filter((
							currentValue) => {
							return currentValue.WorkStatus != 2 && currentValue.WorkStatus != 6 && currentValue.WorkStatus !=
								-1;
						});
						_this.statusList[idx].statusData = _this.statusList[idx].statusDataTotal.slice(0, Math.min(_this
							.statusList[idx].showNum, _this.statusList[idx].statusDataTotal.length));

						// Alarming
						idx++;
						_this.statusList[idx].statusDataTotal = _this.dataFault = res.data.Data.List.filter((currentValue) =>
							currentValue.WorkStatus == 6);
						_this.statusList[idx].statusData = _this.statusList[idx].statusDataTotal.slice(0, Math.min(_this
							.statusList[idx].showNum, _this.statusList[idx].statusDataTotal.length));

						// Offline
						idx++;
						_this.statusList[idx].statusDataTotal = _this.dataOffline = res.data.Data.List.filter((currentValue) =>
							currentValue.WorkStatus == -1);
						_this.statusList[idx].statusData = _this.statusList[idx].statusDataTotal.slice(0, Math.min(_this
							.statusList[idx].showNum, _this.statusList[idx].statusDataTotal.length));
						this.Summary = res.data.Data.Summary;
					}
				})
			},
			showMore(idx) {
				const _this = this;
				_this.statusList[idx].showNum += 20;
				_this.statusList[idx].statusData = _this.statusList[idx].statusDataTotal.slice(0, Math.min(_this.statusList[idx]
					.showNum, _this.statusList[idx].statusDataTotal.length));
			},
			isAllShowed(idx) {
				const _this = this;
				return _this.statusList[idx].statusData.length == _this.statusList[idx].statusDataTotal.length;
			},
			detail: function(ConnectorNo, WorkStatus) {
				const _this = this
				const params = {
					ConnectorNo: ConnectorNo
				}
				_this.$axios.post(webapi.base_api_url + '/Operations/GetEqumentStatusDetail', params).then(res => {
					if (res.data.code != 1) {
						_this.dataDetail = [];
						_this.dataDetail.push(res.data.Data.Detail);
					}
				})
				
				if (WorkStatus == 2) {
					_this.tableShow = true
				} else {
					_this.tableShow = false
				}
				_this.showModel = true
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 300;
			},
			titleColor: function(WorkStatus) {
				let titleClass = '';
				switch (WorkStatus) {
					case 0:
						titleClass = "free cardTitleGreen"
						break;
					case 1:
						titleClass = "free cardTitleBlue"
						break;
					case 2:
						titleClass = "free cardTitleBlue"
						break;
					case 6:
						titleClass = "free cardTitleRed"
						break;
					case -1:
						titleClass = "free cardTitleGrey"
						break;
					default:
						titleClass = "free cardTitleGreen"
						break;
				}
				return titleClass;
			},
			
			circleColor: function(WorkStatus) {
				let titleClass = '';
				switch (WorkStatus) {
					case 0:
						titleClass = "#19be6b"
						break;
					case 1:
						titleClass = "#2d8cf0"
						break;
					case 2:
						titleClass = "#2d8cf0"
						break;
					case 6:
						titleClass = "#ed4e4c"
						break;
					case -1:
						titleClass = "#bbbbbb"
						break;
					default:
						titleClass = "#19be6b"
						break;
				}
				return titleClass;
			},
			circleTextColor: function(WorkStatus) {
				let titleClass = 'font-size:1rem;';
				switch (WorkStatus) {
					case 0:
						titleClass += "color:#19be6b"
						break;
					case 1:
						titleClass += "color:#2d8cf0"
						break;
					case 2:
						titleClass += "color:#2d8cf0"
						break;
					case 6:
						titleClass += "color:#ed4e4c"
						break;
					case -1:
						titleClass += "color:#bbbbbb"
						break;
					default:
						titleClass += "color:#19be6b"
						break;
				}
				return titleClass;
			},
		},
	}
</script>

<style scoped>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.col-24 {
		flex: 0 0 100%;
		max-width: 100%;
	}

	@media (min-width: 1100px) {
		.col-md-12 {
			flex: 0 0 50%;
			max-width: 50%;
		}
	}

	@media (min-width: 1380px) {
		.col-lg-8 {
			flex: 0 0 33.33333333%;
			max-width: 33.33333333%;
		}
	}

	@media (min-width: 1760px) {
		.col-xxl-6 {
			flex: 0 0 25%;
			max-width: 25%;
		}
	}

	@media (min-width: 2140px) {
		.col-xxl-5 {
			flex: 0 0 20%;
			max-width: 20%;
		}
	}

	@media (min-width: 2520px) {
		.col-xxl-4 {
			flex: 0 0 16.66666666666667%;
			max-width: 16.66666666666667%;
		}
	}

	/deep/.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	/deep/.normal {
		margin-bottom: 20px;
		box-shadow: 2px 2px 4px #a7a7a7;
		width: 90% !important;
		height: 160px;
		background-image: linear-gradient(#ffffff, #eeeeee);
		font-size: 6px;
	}

	/deep/.normal .ivu-card-head {
		background-image: linear-gradient(#3FD983, #3aca79);
	}

	/deep/.normal .ivu-card-body {
		padding: 0px 10px;
	}

	/deep/.free {
		margin-bottom: 12px;
		box-shadow: 2px 2px 4px #a7a7a7;
		/* width: 90% !important; */
		height: 150px;
		background-image: linear-gradient(#ffffff, #eeeeee);
		font-size: 6px;
	}

	/deep/.free .ivu-card-body {
		padding: 0px 10px;
	}

	/deep/.cardTitleBlue .ivu-card-head {
		background-image: linear-gradient(#4d9ae7, #55aaff);
	}

	/deep/.cardTitleRed .ivu-card-head {
		background-image: linear-gradient(#ed4e4c, #ed7f7c);
	}

	/deep/.cardTitleGrey .ivu-card-head {
		background-image: linear-gradient(#bbbbbb, #dddddd);
	}

	/deep/.cardTitleGreen .ivu-card-head {
		background-image: linear-gradient(#19be6b, #4ad697);
	}

	/deep/.ivu-card-head p {
		text-align: left;
		color: white;
	}

	/deep/.freeDiv {
		text-align: center;
		height: 100px;
		display: flex;
		flex-direction: row;
		justify-content: center;
	}

	/deep/.freeDiv .ivu-chart-circle-inner {
		/* top: 1.1875rem; */
	}

	/deep/.ivu-chart-circle-inner p {
		font-size: 0.46875rem;
	}

	/deep/.chargeCardClass .ivu-col-span-7 {
		margin-left: 0px;
	}

	/deep/.ivu-chart-circle {
		/* width: 2.8125rem !important; */
		/* height: 2.8125rem !important; */
	}

	/deep/.circle-div {
		float: left;
		width: 22%;
		height: 100%;
		padding: 10px 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-size: 1rem;
	}

	/deep/.statusCard {
		font-size: 0.75rem;
		width: 78%;
		float: right;
		height: 100px;
		padding: 0px 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		flex: 1;
	}

	/deep/.tag {
		background-color: #2d8cf0;
		padding: 0px 2px 0px 2px;
		border-radius: 2px;
	}

	/deep/.label {
		background: transparent !important;
		padding-left: 0;
	}

	/deep/.label .ivu-tag-dot-inner {
		margin-right: 0;
		height: 15px;
		width: 15px;
	}

	/deep/.label .ivu-tag-text {
		font-size: 20px;
	}

	/deep/.loginBg .ivu-card-bordered,
	.ivu-card {
		margin-right: 0;
	}
</style>
